export default __webpack_public_path__ + "static/media/framerMotionC.7befc720.webp";